import { render, staticRenderFns } from "./SettlementOfClosing.vue?vue&type=template&id=77b95790&scoped=true&"
import script from "./SettlementOfClosing.vue?vue&type=script&lang=js&"
export * from "./SettlementOfClosing.vue?vue&type=script&lang=js&"
import style0 from "./SettlementOfClosing.vue?vue&type=style&index=0&id=77b95790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b95790",
  null
  
)

export default component.exports